var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJiraicon = function SvgJiraicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2684FF",
    d: "M27.006 4H15.45a5.21 5.21 0 0 0 5.212 5.211h2.125v2.058A5.21 5.21 0 0 0 28 16.48V4.994A.995.995 0 0 0 27.006 4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jira_icon_svg__a)",
    d: "M21.28 9.76H9.726a5.21 5.21 0 0 0 5.211 5.211h2.126v2.058a5.21 5.21 0 0 0 5.211 5.211V10.754a.995.995 0 0 0-.994-.994Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jira_icon_svg__b)",
    d: "M15.554 15.52H4a5.21 5.21 0 0 0 5.211 5.211h2.126v2.058A5.21 5.21 0 0 0 16.55 28V16.514a.995.995 0 0 0-.995-.994Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jira_icon_svg__a",
    x1: 22.034,
    x2: 17.118,
    y1: 9.773,
    y2: 14.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jira_icon_svg__b",
    x1: 16.641,
    x2: 10.957,
    y1: 15.564,
    y2: 21.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
};
export default SvgJiraicon;